module.exports = __webpack_public_path__ + "img/53_11.ac648741.png";